// LoaderPage.js
import React from 'react';
import './LoaderPage.css'; // Import the CSS for styling the loader page
import loadingLogo from '../assets/img/loading_logo.gif'; // Import the gif

const LoaderPage = () => {
  return (
    <div className="loader-page">
      <img src={loadingLogo} alt="Loading..." className="loading-logo" />
      {/* <p className="loading-text">Loading...</p> */}
    </div>
  );
};

export default LoaderPage;
